import React from "react";
import moment from "moment";
import "moment/locale/fr";
import { Link } from "react-router-dom";

import { Can } from "constants/abilityContext";
import {
  ACCIDENT_TYPE_ACCIDENT,
  ACCIDENT_TYPE_NEARMISS,
  DOCUMENT_TYPE_PHOTO,
  interventionType,
} from "constants/dbValues";
import { icons } from "constants/icons";
import { projectService, noteService, documentService } from "services";
import { imagePath } from "utils";
import { Icon } from "antd";

export const cards = {
  home: {
    service: projectService,
    func: "homeList",
    generateCard: (group) => {
      let accidentValue = (group.incident || {}).accident;
      if (typeof accidentValue === "undefined") accidentValue = "-1";

      const tailgateOK = moment().diff(moment((group.tailgate || {}).date), "hours") <= 24;
      const incidentStatus =
        accidentValue === "-1"
          ? ""
          : accidentValue == ACCIDENT_TYPE_ACCIDENT
            ? "accident"
            : accidentValue == ACCIDENT_TYPE_NEARMISS
              ? "nearmiss"
              : "incident";
      const sseStatus = group.sse ? "sse" : "";

      return {
        classes: "home " + incidentStatus,
        title: group.project.label,
        descr: `${group.client.name} / ${group.project.code}`,
        client: {
          ...group.client,
          document: (group.client.document || []).find((d) => d.type_id === DOCUMENT_TYPE_PHOTO),
        },
        image: group.documents[0] ? imagePath((group.documents[0] || {}).url, true) : "/images/logo.png",
        users: group.users,
        link: `/projects/${group.project.id}`,
        extraHeader: (
          <>
            {group.risks && Array.isArray(group.risks) && (
              <Link className="risks-list" to={`/projects/${group.project.id}`}>
                {(group.risks.slice(0, 3) || []).map((r, i) => (
                  <span key={i} className="risk-picto smaller">
                    <img
                      src={process.env.PUBLIC_URL + "/images/risks/" + (r.picto || "default.png")}
                    />
                  </span>
                ))}
              </Link>
            )}

            {(incidentStatus || sseStatus) && (
              <div className="incidents-sse-list">
                <span className="alert-icon">
                  <Icon type="notification" />
                </span>
                {incidentStatus && (
                  <Link to={`/incidents/${group.incident.id}`}>
                    <Icon type={icons.incident} className={incidentStatus} />
                  </Link>
                )}
                {sseStatus && (
                  <Link to={`/sse/${group.sse.id}`}>
                    <Icon type={icons.sse} />
                  </Link>
                )}
              </div>
            )}
          </>
        ),
        extraBody: (
          <>
            <Can do="read_admin" on="General">
              {group.project.estimated_hours_clb && group.project.estimated_hours_subcontractor ? (
                <div className="hours-count">
                  <span>
                    <Icon type="user" /> CLB{" "}
                    <b>
                      {group.total_hours_contractor || 0} / {group.project.estimated_hours_clb || 0}
                    </b>
                  </span>
                  <span>
                    <Icon type="user" /> STR{" "}
                    <b>
                      {group.total_hours_subcontractor || 0} /{" "}
                      {group.project.estimated_hours_subcontractor || 0}
                    </b>
                  </span>
                </div>
              ) : (
                <></>
              )}
            </Can>

            {(group.tailgate || {}).date && (
              <small className={"last-tailgate " + (tailgateOK ? "green" : "")}>
                Dernier tailgate :<b>{moment((group.tailgate || {}).date).fromNow()}</b>
                <Icon type={tailgateOK ? "check-circle" : "clock-circle"} />
              </small>
            )}
          </>
        ),
      };
    },
    filter: true,
    searchFields: ["project.label", "client.name", "project.code"],
  },

  projects: {
    service: projectService,
    generateCard: (project) => {
      const photos = project.document_photos;

      return {
        title: project.label,
        descr: `${project.client.name} / ${project.code}`,
        image: (((photos || [])[photos.length - 1] || {}).url || {}).url,
        users: project.users,
        link: `/projects/${project.id}`,
      };
    },
    filter: true,
    searchFields: ["label", "client.name", "code"],
  },

  sse: {
    service: noteService,
    preSort: (data) =>
      data.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      }),

    generateCard: (sse) => {
      const type = interventionType(sse.intervention_type);

      return {
        classes: `sse${type ? ` sse--${type.key}` : ""}`,
        extraHeader: (
          <>
            <span className="sse-number">{`Intervention #${sse.id}`}</span>
            {type && <span className="sse-type">{type.label}</span>}
          </>
        ),
        title: (sse.project || {}).label,
        descr: `${((sse.project || {}).client || {}).name} / ${(sse.project || {}).code}`,
        extraBody: <small className="last-tailgate">{moment(sse.date).fromNow()}</small>,
        users: sse.user
          ? [
              {
                ...sse.user,
                document: sse.user.documents ? sse.user.documents[0] : {},
                visitor_name: sse.visitor_name,
              },
            ]
          : [],
        link: `/sse/${sse.id}`,
        image: () => {
          const url = imagePath(
            (sse.documents || []).find((d) => d.type_id === DOCUMENT_TYPE_PHOTO)?.url,
          );
          return (
            <>
              <span>{`«\u00A0${sse.text}\u00A0»`}</span>
              <div className="image-sse" style={{ backgroundImage: `url(${url})` }} />
            </>
          );
        },
      };
    },
    filter: true,
    lastWeekFilter: true,
    filtersDefaultValue: { lastWeek: true },
    searchFields: ["text", "project.label", "project.code"],
  },

  documents: {
    service: documentService,
    generateCard: (document) => ({
      title: "",
      descr: "",
      image: document.url,
      users: "",
    }),
  },
};
